import { useEffect } from 'react';

const CLICK_EVENT = 'mousedown';

export function useClickOutside(
  ref: React.RefObject<HTMLElement>,
  callback: () => void,
  deps: any[]
) {
  const onClick = (e: MouseEvent) => {
    if (
      e.target &&
      ref.current &&
      !ref.current.contains(e.target as HTMLElement)
    ) {
      callback();
    }
  };

  useEffect(() => {
    document.addEventListener(CLICK_EVENT, onClick);
    return () => {
      document.removeEventListener(CLICK_EVENT, onClick);
    };
  }, deps);
}
